import React from 'react';
import UserProfile from '../shared/UserProfile';

const ProofreaderProfile = () => {
  return <UserProfile />;
};

export default ProofreaderProfile;